module.exports = __webpack_public_path__ + "c2f29c4d57cfcba3c9b2374b2c7e461f.svg";